export const getStrapiAssetURL = (url) =>{
    if(process.env.REACT_APP_STRAPI_API_URL.includes("http://localhost")){
        return process.env.REACT_APP_STRAPI_API_URL + url
    }
    return url
}